function Nav() {
  return (
    <nav className="flex justify-between items-center px-6 py-7 max-w-3xl mx-auto border-b border-light-gray">
      <span className="font-display font-extrabold text-base text-navy">
        Helin Okcu
      </span>
      <div className="flex gap-4 sm:gap-6">
        {[
          { label: "LinkedIn", href: "https://linkedin.com/in/helinokcu" },
          { label: "GitHub", href: "https://github.com/xhokcu" },
          { label: "Medium", href: "#" },
        ].map((link) => (
          <a
            key={link.label}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[12px] sm:text-[13px] text-warm-gray hover:text-coral transition-colors duration-200"
          >
            {link.label}
          </a>
        ))}
      </div>
    </nav>
  );
}

export default Nav;
